import createEnum from 'scripts/lib/create_enum';

import AssignedTaskCommented from './assigned_task_commented';
import FollowedTaskCommented from './followed_task_commented';
import AssignedTaskResponseReceived from './assigned_task_response_received';
import FollowedTaskResponseReceived from './followed_task_response_received';
import AssignedTaskReplied from './assigned_task_replied';
import FollowedTaskReplied from './followed_task_replied';

import AssignedTaskClosed from './assigned_task_closed';
import FollowedTaskClosed from './followed_task_closed';

import AgentMentionedInItem from './agent_mentioned_in_item';
import AgentMentionedInTaskComment from './agent_mentioned_in_task_comment';

const AgentNotificationType = createEnum(
  'ASSIGNED_TASK_COMMENTED',
  'FOLLOWED_TASK_COMMENTED',
  'ASSIGNED_TASK_RESPONSE_RECEIVED',
  'FOLLOWED_TASK_RESPONSE_RECEIVED',
  'ASSIGNED_TASK_REPLIED',
  'FOLLOWED_TASK_REPLIED',
  'ASSIGNED_TASK_CLOSED',
  'FOLLOWED_TASK_CLOSED',
  'ITEM_MENTION',
  'ITEM_MENTION_COMMENT'
);
export { AgentNotificationType };

const AgentNotificationContentClasses = [
  [AgentNotificationType.ASSIGNED_TASK_CLOSED, AssignedTaskClosed],
  [AgentNotificationType.FOLLOWED_TASK_CLOSED, FollowedTaskClosed],

  [AgentNotificationType.ASSIGNED_TASK_COMMENTED, AssignedTaskCommented],
  [AgentNotificationType.FOLLOWED_TASK_COMMENTED, FollowedTaskCommented],
  [AgentNotificationType.ASSIGNED_TASK_RESPONSE_RECEIVED, AssignedTaskResponseReceived],
  [AgentNotificationType.FOLLOWED_TASK_RESPONSE_RECEIVED, FollowedTaskResponseReceived],
  [AgentNotificationType.ASSIGNED_TASK_REPLIED, AssignedTaskReplied],
  [AgentNotificationType.FOLLOWED_TASK_REPLIED, FollowedTaskReplied],

  [AgentNotificationType.ITEM_MENTION, AgentMentionedInItem],
  [AgentNotificationType.ITEM_MENTION_COMMENT, AgentMentionedInTaskComment],
];
export default AgentNotificationContentClasses;
